import React from 'react';
import { FormattedMessage } from 'react-intl';
import randomstring from 'uuid/v4';

import Grid from '@material-ui/core/Grid';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/AddCircle';

import LinkIcon from '@material-ui/icons/Link';
import UnlinkIcon from '@material-ui/icons/LinkOff';

// eslint-disable-next-line
import style from './_style.css';

class Sensors extends React.Component {
    handleDelete = (sensor) => (event) => {
        this.props.onDelete(sensor);
    };

    handleEdit = (sensor) => (event) => {
        this.props.onEdit(sensor);
    };

    handleAdd = (event) => {
        if (this.props.local) this.props.onAdd();
    };

    render() {
        const { sensores } = this.props;
        const data = sensores && sensores.length > 0 ? sensores : [];
        return (
            <div className={'margin_top_24'}>
                <div className="flex_full_row align_center">
                    <div className={'barlow_medium_italic c_slate_grey flex_full_row'}>
                        <FormattedMessage id="form_field_name_sensors" />
                    </div>
                    <AddIcon
                        disabled={!this.props.local}
                        className={this.props.local ? 'c_bluish hand' : 'c_lipstick hand'}
                        fontSize="large"
                        onClick={this.handleAdd}
                    />
                </div>
                <Grid
                    container
                    justify="center"
                    className={'flex_grow_1 align_center termometres_table margin_top_8'}
                >
                    <Grid item xs={3} className={'barlow_regular_textwrap termometres_cell_header'}>
                        <FormattedMessage id="form_field_name_nombre" />
                    </Grid>
                    <Grid item xs={2} className={'barlow_regular_textwrap termometres_cell_header'}>
                        <FormattedMessage id="form_field_name_sensorId" />
                    </Grid>
                    <Grid item xs={2} className={'barlow_regular_textwrap termometres_cell_header'}>
                        <FormattedMessage id="form_field_name_sensorCode" />
                    </Grid>
                    <Grid item xs={2} className={'barlow_regular_textwrap termometres_cell_header'}>
                        <FormattedMessage id="field" />
                    </Grid>
                    <Grid
                        item
                        xs={3}
                        className={'barlow_regular_textwrap nowrap termometres_cell_header'}
                    />
                    {data &&
                        data.length > 0 &&
                        data.map((s, i) => {
                            return (
                                <React.Fragment key={randomstring()}>
                                    <Grid
                                        item
                                        xs={3}
                                        className={
                                            'barlow_regular_textwrap termometres_cell' +
                                            (data.length === i + 1 ? '_last' : '')
                                        }
                                    >
                                        {s.nombre}
                                    </Grid>
                                    <Grid
                                        item
                                        xs={2}
                                        className={
                                            'barlow_regular_textwrap termometres_cell' +
                                            (data.length === i + 1 ? '_last' : '')
                                        }
                                    >
                                        {s.sensorId}
                                    </Grid>
                                    <Grid
                                        item
                                        xs={2}
                                        className={
                                            'barlow_regular_textwrap termometres_cell' +
                                            (data.length === i + 1 ? '_last' : '')
                                        }
                                    >
                                        {s.sensorCode}
                                    </Grid>
                                    <Grid
                                        item
                                        xs={2}
                                        className={
                                            'barlow_regular_textwrap termometres_cell' +
                                            (data.length === i + 1 ? '_last' : '')
                                        }
                                    >
                                        {s.campos && s.campos.length > 0 ? (
                                            <LinkIcon />
                                        ) : (
                                            <UnlinkIcon />
                                        )}
                                    </Grid>
                                    <Grid
                                        item
                                        xs={3}
                                        className={
                                            'barlow_regular_textwrap nowrap termometres_cell' +
                                            (data.length === i + 1 ? '_last' : '')
                                        }
                                    >
                                        <EditIcon
                                            className={'c_bluish hand'}
                                            onClick={this.handleEdit(s)}
                                        />
                                        <DeleteIcon
                                            className={'c_bluish hand'}
                                            onClick={this.handleDelete(s)}
                                        />
                                    </Grid>
                                </React.Fragment>
                            );
                        })}
                </Grid>
            </div>
        );
    }
}

export default Sensors;



// WEBPACK FOOTER //
// ./src/components/complex/manage/termometre/Sensors.js